import store from '../store/index'

//------------------------
// clear campaign combatants
//------------------------
export default function clearCampaignCombatants() {
  // console.log("--------------------");
  // console.log("IN clearCampaignCombatants...");
  //--------------
  // access store
  //--------------
  const this_store = store.state.combat
  //-------------
  // clear array
  //-------------
  this_store.arena.arena_combatants.splice(0)
}
